import { Theme } from '@mui/material/styles'

const useStyles = {
  accordion: (theme: Theme) => ({
    border: '1px solid transparent',
    '&.Mui-expanded': {
      border: `1px solid rgba(0, 0, 0, 0.12)`,
      borderRadius: theme.shape.mediumBorderRadius,
      overflow: 'hidden',
    },
  }),
  accordionSummary: (theme: Theme) => ({
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      color: theme.palette.primary.main,
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
    '&.Mui-expanded': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  }),
  summaryFieldTitle: {
    lineHeight: 0.5,
  },
  copyIconButton: (theme: Theme) => ({
    padding: 0,
    marginLeft: theme.spacing(1),
    width: '24px',
    height: '24px',
  }),
  copyIcon: {
    fontSize: '16px',
  },
  orderIcon: {
    height: '48px',
    aspectRatio: 1,
  },
  loadingWrapper: (theme: Theme) => ({
    marginTop: theme.spacing(1),
  }),
  orderModal: (theme: Theme) => ({
    zIndex: theme.zIndex.drawer + 2,
  }),
  orderPaper: (theme: Theme) => ({
    borderTopLeftRadius: theme.shape.mediumBorderRadius + 4,
    borderTopRightRadius: theme.shape.mediumBorderRadius + 4,
    height: 'calc(100vh - 40px)',
    overflowY: 'unset',
  }),
  orderModalCloseButton: (theme: Theme) => ({
    position: 'absolute',
    zIndex: 100,
    top: '-40px',
    right: 0,
    color: theme.palette.background.paper,
  }),
}

export default useStyles
